import { SurveyFrequency, SurveyDay } from "./SurveyFrequency";
import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(weekOfYear)

export class SurveyScheduler {
    constructor(public previousSurveyDate: Date | null,
        public surveyFrequency: SurveyFrequency,
        public surveyDay: SurveyDay) {

    }

    get surveyDayAsIndex() {
        switch (this.surveyDay) {
            case 'Monday': return 1;
            case 'Tuesday': return 2;
            case 'Wednesday': return 3;
            case 'Thursday': return 4;
            case 'Friday': return 5;
            case 'Saturday': return 6;
            case 'Sunday': return 7;
        }
    }

    public nextSurveyDate() {
        switch(this.surveyFrequency) {
            case 'monthly': {
                if (this.previousSurveyDate) {
                    const currentMonthNumber = dayjs().month();
                    const lastSurveyMonth = dayjs(this.previousSurveyDate).month();
                    if (currentMonthNumber - lastSurveyMonth >= 1) {
                        // this month
                        const nextDate = dayjs().month(currentMonthNumber).date(1).day(this.surveyDayAsIndex);
                        return nextDate.toDate();
                    } else {
                        // next week or the one after
                        const nextDate = dayjs().month(currentMonthNumber + 1).date(1).day(this.surveyDayAsIndex);
                        return nextDate.toDate();
                    }
                } else {
                    const currentMonthNumber = dayjs().month();
                    const nextDate = dayjs().month(currentMonthNumber + 1).date(1).day(this.surveyDayAsIndex);
                    return nextDate.toDate();
                }
            }
            case 'bi-weekly':
            case 'weekly': {
                if (this.previousSurveyDate) {
                    const weeksToSeperateBy = this.surveyFrequency === 'weekly' ? 1 : 2;
                    const currentWeekNumber = dayjs().week();
                    const lastSurveyWeek = dayjs(this.previousSurveyDate).week();
                    
                    if (currentWeekNumber - lastSurveyWeek >= weeksToSeperateBy) {
                        // this week
                        const nextDate = dayjs().week(currentWeekNumber).day(this.surveyDayAsIndex);
                        return nextDate.toDate();
                    } else {
                        // next week or the one after
                        const doInWeek = lastSurveyWeek + weeksToSeperateBy;
                        const nextDate = dayjs().week(doInWeek).day(this.surveyDayAsIndex);
                        return nextDate.toDate();
                    }
                } else {
                    const currentWeekNumber = dayjs().week();
                    const nextDate = dayjs().week(currentWeekNumber + 1).day(this.surveyDayAsIndex);
                    return nextDate.toDate();
                }
            }
        }
    }
}